import styled, { css } from 'styled-components';

import { Checkbox } from '@speeki/global-ui-components';

import { Card } from '@components/molecules/Card/Card';

import { maxWidth } from '@utils/helpers';

export const CardWrapper = styled(Card)(
    ({ theme: { fontSize } }) => css`
        ${Card.Title} {
            margin-bottom: 4px;

            ${maxWidth('xs')} {
                font-size: ${fontSize[24]}px;
                line-height: 36px;
            }
        }

        ${Card.Description} {
            margin-bottom: 0;
        }
    `,
);

export const PinWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding: 24px 0;
`;

export const ResetButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;

    button {
        min-width: unset;
    }
`;

export const EnterCodeCheckbox = styled(Checkbox)`
    margin-bottom: 16px;

    ${maxWidth('md')} {
        display: flex;
        justify-content: center;
    }
`;
